import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=db7c639e&scoped=true"
import script from "./HeaderNotification.vue?vue&type=script&lang=js"
export * from "./HeaderNotification.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=db7c639e&prod&scoped=true&lang=css"
import style1 from "./HeaderNotification.vue?vue&type=style&index=1&id=db7c639e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c639e",
  null
  
)

export default component.exports